import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MessageService } from '../services/message.service';
import {
  deleteSpam,
  setSpam,
  setSpamError,
  setSpamSuccess,
  viewMessage,
  viewMessageSuccess,
} from '../actions/message.action';
import { of } from 'rxjs';

@Injectable()
export class MessageEffect {
  viewMessage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(viewMessage),
        switchMap(action =>
          this.messageService.viewMessage(
            action.id_message,
            action.lock,
            action.unlock,
            action.page,
          ),
        ),
        map(res =>
          viewMessageSuccess({
            messages: res.items,
            extraData: res.extra_data,
            currentPage: res.current_page,
            hasMoreData: res.has_more_data,
          }),
        ),
      ),
    /**
     * TODO: check how the multiple messages are diplayed and adjust the REDUX according it
     */
  );

  setSpam$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setSpam),
      switchMap(action =>
        this.messageService.setSpam(action.id, action.spam).pipe(
          map(res => setSpamSuccess({ messages: res.items })),
          catchError(error => of(setSpamError({ error }))),
        ),
      ),
    ),
  );

  deleteSpam$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteSpam),
      switchMap(action =>
        this.messageService.deleteSpam().pipe(
          map(res => setSpamSuccess({ messages: res.items })),
          catchError(error => of(setSpamError({ error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private messageService: MessageService,
  ) {
  }
}
